import React, { useState } from 'react';
import { Button, IconButton, Menu, MenuItem } from '@mui/material';
import RoomIcon from '@mui/icons-material/Room';

type Props = {
  address?: string;
};

const NavigateMenuButton = ({ address = '' }: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const encodedAddress = encodeURIComponent(address);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const openInMaps = (type: 'google' | 'waze' | 'apple') => {
    handleClose();
    const query = encodedAddress;
    switch (type) {
      case 'google':
        window.open(`https://www.google.com/maps/search/?api=1&query=${query}`, '_blank');
        break;
      case 'waze':
        window.open(`https://waze.com/ul?q=${query}&navigate=yes`, '_blank');
        break;
      case 'apple':
        window.open(`https://maps.apple.com/?q=${query}`, '_blank');
        break;
    }
  };


  return (
    <>
      <IconButton
        size="small"
        onClick={handleClick}
        color='primary'
      >
        <RoomIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={() => openInMaps('google')}>Google Maps</MenuItem>
        <MenuItem onClick={() => openInMaps('waze')}>Waze</MenuItem>
        <MenuItem onClick={() => openInMaps('apple')}>Apple Maps</MenuItem>
      </Menu>
    </>
  );
};

export default NavigateMenuButton;
